// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folders_dropdown_create_text-module__container--L3u1p{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px}\n", ""]);
// Exports
exports.locals = {
	"container": "folders_dropdown_create_text-module__container--L3u1p"
};
module.exports = exports;
